export default __webpack_public_path__ + "static/media/six.3b76d4fa.svg";